import { render } from "./StudentTabs.vue?vue&type=template&id=fb35cd90&scoped=true"
import script from "./StudentTabs.vue?vue&type=script&lang=js"
export * from "./StudentTabs.vue?vue&type=script&lang=js"

import "./StudentTabs.vue?vue&type=style&index=0&id=fb35cd90&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb35cd90"]])

export default __exports__